import type { MutationResult } from '@apollo/client';
import { useCallback } from 'react';

import type { ArchiveJobMutation } from 'src/shared/graphql/generated';
import { useArchiveJobMutation } from 'src/shared/graphql/generated';
import { logError } from 'src/shared/telemetry/logger';

type DeleteHandlerParams = {
  onSuccess: () => void;
  onError: () => void;
};

export const useDeleteScanHandler = (
  scanId: number,
): [
  (params: DeleteHandlerParams) => void,
  MutationResult<ArchiveJobMutation>,
] => {
  const [deleteScanMutation, deleteScanResponse] = useArchiveJobMutation();

  const deleteScanClickHandler = useCallback(
    async ({ onSuccess, onError }: DeleteHandlerParams) => {
      if (!scanId) return;

      const deleteScanResult = await deleteScanMutation({
        variables: {
          id: scanId,
        },
      });

      if (deleteScanResult.errors?.length) {
        deleteScanResult.errors.forEach(e => logError(e));
        onError();
        return;
      }

      onSuccess();
    },
    [deleteScanMutation, scanId],
  );

  return [deleteScanClickHandler, deleteScanResponse];
};
